import settings from './settings.js'
export default {
    data(){
        return{
            //territory_list lazy loading
            territories_loading: false,
            temp_territories: [],
            territory_count: 0,
            territory_scrollable: false,
            territories_visible: false,
            territory_list:[]
        }
    },
    mixins:[settings],
    methods:{
        async searchTerritory(territory){
            this.territories_loading = true
            let response = await this.Listterritory_list({
                search_key: territory
            })
            this.territory_list = response.response
            this.territory_list = this.territory_list.filter(x => {
                if(x.name){
                    return x
                }
            })
            this.territory_count = this.territory_list.length
            this.territories_loading = false
            this.territory_scrollable = false
        },
        async reachedEndOfTerritoryList(reached) {
            this.territories_visible = reached
            if (reached) {
                if (this.territory_scrollable == false) {
                    this.territories_loading = true
                    let response = await this.getTerritoryList({
                        skip: this.territory_count,
                        limit: 10
                    })
                    this.temp_territories = response.response.length;
                    if (response.skip == this.territory_count) {
                        if (this.temp_territories > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.territory_list.push(el);
                                this.territory_list = this.territory_list.filter(x => {
                                    if(x.name){
                                        return x
                                    }
                                })
                            });
                            this.territory_count += response.response.length;
                            this.territories_loading = false
                        } else {
                            this.territory_scrollable = true
                            this.territories_loading = false
                        }
                    }
                    this.territories_loading = false
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/territory_lazy_loading.js